import { padStart, pickBy } from "lodash";
import moment from "moment-timezone";

import { CollateralFilter, GiroType } from "../../../../graphql/generated.ts";
import { GiroManagementFiltersValue } from "./types.ts";

export const getGiroManagementApiFilter = (
  value: GiroManagementFiltersValue
): CollateralFilter => {
  const dueDatePeriod =
    !!value.dueDate && !!value.dueDate[0] && !!value.dueDate[1];

  return pickBy({
    giroType: value.type && { equals: value.type },
    collateralBuyerNumber: value.collateralBuyerNumber?.length && {
      in: value.collateralBuyerNumber,
    },
    status: value.status && { equals: value.status },
    dueDate: !!value.dueDate &&
      dueDatePeriod && {
        gte: value.dueDate[0],
        lte: value.dueDate[1],
      },
  });
};

export const getGiroNumber = (
  type: GiroType | undefined,
  partnerCode: string | null | undefined,
  count: number | null | undefined
) => {
  const parsedDate = moment(new Date(), "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
  const formattedDate = parsedDate.format("DD-MM-YY");
  const formattedCount = padStart((count ? count + 1 : 1).toString(), 4, "0");
  const formattedType = type?.replace(/_/g, "-").toUpperCase();
  return `${formattedType}-${partnerCode}-${formattedDate}-${formattedCount}`;
};
